/**
 * These constants are used to determine the behaviour and display of
 * the mentor profiles page.
 */

export const mobileProfilesPerPage = 2;
export const fullsizeProfilesPerPage = 12;
export const mobileScreenSize = 768;
